<smrts-dialog [title]="title" [hasFootnote]="true" fixedHeight="600px">

  <p-splitter [style]="{ height: '100%' }" [panelSizes]="[50, 50]" class="mb-8">
    <ng-template #panel>
      <div class="splitter-panel-content">
        <app-correspondencia-table [lancamentos]="lancamentosBanco" nome="Extrato"></app-correspondencia-table>
      </div>
    </ng-template>

    <ng-template #panel>
      <div class="splitter-panel-content">
        <app-correspondencia-table [lancamentos]="lancamentosCaixa" nome="Caixa"></app-correspondencia-table>
      </div>
    </ng-template>
  </p-splitter>

  <div footnote class="inline-element footnote">
    <div class="diferenca-container">
      Diferença: {{ diferencaValores | currency:'BRL' }}
    </div>

    @if (acaoDesfazer) {
      <div class="inline-element">
        <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
          Cancelar
        </button>
        <button class="button desfazer-btn" mat-flat-button [mat-dialog-close]="true" (click)="desfazerCorrespondenciaClick()">
          Desfazer
        </button>
      </div>
    }

    @if (!acaoDesfazer) {
      <div>
        <button class="white-text-button" mat-flat-button [mat-dialog-close]="true">
          Ok
        </button>
      </div>
    }
  </div>

</smrts-dialog>